import {useState, useEffect} from 'react'

export default function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)
  const [wasOffline, setWasOffline] = useState<boolean>(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      // Don't immediately reset wasOffline - let component handle it
      setTimeout(() => setWasOffline(false), 3000) // Show reconnection message for 3s
    }

    const handleOffline = () => {
      setIsOnline(false)
      setWasOffline(true)
    }

    // Add event listeners
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Periodic check (every 5 seconds) as backup
    const intervalId = setInterval(() => {
      const currentStatus = navigator.onLine
      if (currentStatus !== isOnline) {
        setIsOnline(currentStatus)
        if (!currentStatus) setWasOffline(true)
      }
    }, 5000)

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      clearInterval(intervalId)
    }
  }, [isOnline])

  return {isOnline, wasOffline}
}

